import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IDataStat {
    timestamp: number
    spot_size: number
    long_size: number
    short_size: number
    buy_vol: number
    sell_vol: number
    long_vol: number
    short_vol: number
    price: number
}

export const getDataStat = async (): Promise<ApiRes<IDataStat[]>> => {
    return await apiGet(API_URL, `admin/tamp/stat`)
}
